import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { IconMenu, MenuItem } from 'react-toolbox/lib/menu'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import { GLOBAL_ROLES, PROJECT_ROLES } from 'containers/Role/constants'
import { mapProps, compose } from 'recompose'

import styles from './styles.scss'

const showToTeamOrAdmin = compose(
  mapProps((props) => ({
    ...props,
    roles: [
      ...Object.values(PROJECT_ROLES),
      GLOBAL_ROLES.ADMIN_ACCESS
    ]
  })),
  showOnAnyRoles
)

const UpdateEntryMenu = (props) => {
  const {
    onDelete
  } = props

  return (
    <IconMenu
      icon='more_vert'
      position='auto'
      menuRipple
    >
      <MenuItem
        onClick={onDelete}
        icon='delete'
        caption='Delete'
      />
    </IconMenu>
  )
}


const withStyle = CSSModules(styles)

const enhance = compose(
  withStyle,
  showToTeamOrAdmin
)
export default enhance(UpdateEntryMenu)
